import { createAction, props } from '@ngrx/store';

export interface Modified {
  modified: boolean;
}

export const set = createAction('SET_MODIFIED', props<Modified>());
